import Base from "@/api/Base";

export default class Resend extends Base
{
	setApplicationId (v)
	{
		this.applicationId = v;
		return this;
	}

	setApplicationSecurityToken (v)
	{
		this.applicationSecurityToken = v;
		return this;
	}

	setType (v)
	{
		this.data.type = v;
		return this;
	}

	setPhoneNumber (v)
	{
		this.data.phoneNumber = v;
		return this;
	}

	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		if (this.applicationId && this.applicationSecurityToken)
		{
			return '/kandidat/' + this.applicationId + '/' + this.applicationSecurityToken + '/legitimierung/erneut-senden';
		}

		return '/kandidat/legitimierung/erneut-senden';
	}
}
